import { useState, useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { navbar } from '../constants/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';

const Navbar = () => {
    const [active, setActive] = useState("about");
    const [menuOpened, setMenuOpened] = useState(false);
    const sectionRefs = useRef({});
    const controls = useAnimation();
    const logoControls = useAnimation();

    useEffect(() => {
        controls.start({ 
            height: menuOpened ? "auto" : 0,
            transition: { duration: 0.3, ease: "easeInOut" }
        });
        logoControls.start({ opacity: active === "home" ? 0 : 1, y: active === "home" ? -20 : 0 });
    }, [menuOpened, active, controls, logoControls]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100;
            const activeSection = Object.keys(sectionRefs.current).find(id =>
                sectionRefs.current[id].offsetTop <= scrollPosition &&
                sectionRefs.current[id].offsetTop + sectionRefs.current[id].offsetHeight > scrollPosition
            );

            if (activeSection && active !== activeSection) {
                setActive(activeSection);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [active]);

    const scrollToSection = (id) => {
        const section = sectionRefs.current[id];
        if (section) {
            window.scrollTo({ top: section.offsetTop, behavior: 'smooth' });
        }
    };

    return (
        <nav className='w-full fixed top-0 px-10 py-5 bg-primary flex items-center z-50'>
            {/* Logo */}
            <motion.div
                className='w-full flex justify-start cursor-pointer'
                onClick={() => scrollToSection("home")}
                animate={logoControls}
            >
                <img src={logo} alt='' className='w-10 h-10 object-contain' />
            </motion.div>

            {/* Desktop menu */}
            <ul className='list-none hidden lg:flex flex-row gap-5'>
                {navbar.links.map((link) => (
                    <motion.li
                        key={link.id}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        className={`${active === link.id ? 'text-white' : 'text-gray-400'} hover:text-white`}
                        onClick={() => scrollToSection(link.id)}
                    >
                        <a href={`#${link.id}`}>{link.title}</a>
                    </motion.li>
                ))}
            </ul>

            {/* Menu icon for mobile */}
            <div className='text-white lg:hidden'>
                <FontAwesomeIcon
                    icon={menuOpened ? faXmark : faBars}
                    onClick={() => setMenuOpened(!menuOpened)}
                />
            </div>

            {/* Vertical menu for mobile */}
            {menuOpened && (
                <motion.ul
                    initial={{ height: 0 }}
                    animate={controls}
                    className='list-none lg:hidden text-center flex flex-col absolute top-full w-full py-5 left-0 bg-primary'
                >
                    {navbar.links.map((link) => (
                        <motion.li
                            key={link.id}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            className={`${active === link.id ? 'text-white' : 'text-gray-400'} hover:text-white py-2`}
                            onClick={() => {
                                setActive(link.id);
                                setMenuOpened(false);
                            }}
                        >
                            <a href={`#${link.id}`}>{link.title}</a>
                        </motion.li>
                    ))}
                </motion.ul>
            )}
        </nav>
    );
};

export default Navbar;
